import { useEffect } from "react";
import DrawerModal from "./components/DrawerModal";
import { applyFontFromConfig, font } from "./configs";
import { logger } from "./utils";

import "./App.css";

function App() {
  useEffect(() => {
    applyFontFromConfig(font).catch((err) =>
      logger.warn("Font load failed:", err)
    );
  }, []);

  return <DrawerModal />;
}

export default App;
